import type { ScreenBase } from "@frui.ts/screens/dist";
import { Router } from "@frui.ts/screens/dist";
import { Modules } from "../../config";
import LocalizationService from "../../services/localizationService";
import AppRouter from "../../services/router";
import SecurityService from "../../services/securityService";
import AccessRightsViewModel from "./accessRights/accessRightsViewModel";
import RolesViewModel from "./roles/rolesViewModel";
import UsersViewModel from "./users/usersViewModel";
import ModuleViewModel from "../moduleViewModel";

@Router.registerRoute({
  route: Modules.users,
  name: Router.Self,
  children: [UsersViewModel, RolesViewModel, AccessRightsViewModel],
})
export default class UsersModuleViewModel extends ModuleViewModel<ScreenBase> {
  protected readonly module = Modules.users;

  constructor(
    protected localizationService: LocalizationService,
    private securityService: SecurityService,
    private appRouter: AppRouter,
    private usersViewModel: UsersViewModel,
    private rolesViewModel: RolesViewModel,
    private accessRightsViewModel: AccessRightsViewModel
  ) {
    super();
    this.navigationName = this.module;

    if (this.securityService.allowTo("users")) {
      this.children.push(this.usersViewModel, this.rolesViewModel, this.accessRightsViewModel);
    }
  }
}
